<div class="mb-2">
    <hr class="pdfDocumentType"/>
    <div class="mt-1 mb-1 resultHeader">
        <div class="iconStyling">
            <img src="../../../../assets/images/OAFDBlue.png" aria-hidden="true" alt="">
            <span class="ml-2">{{ 'assessment.pdf.results.card.header' | translate | async }}</span>
        </div>
        <div class="iconStyling recordIcon">
            <img src="../../../../assets/images/pdf-icon-blue.png" 
                alt="{{ 'documentIcon' | translate | async }}" 
                attr.aria-label="{{ 'documentIcon' | translate | async }}" aria-hidden="true">
        </div>
    </div>

    <div class="resultsCardContainer">
        <div class="flex mb-0">
            <p class="resultsCardSubtitle font-weight--bold ">{{ 'file.name' | translate | async }}</p>
            <a class="recordValue"
                target="_blank" 
                href="{{file_path}}">
                {{ file_name }}
            </a>                                            
        </div>
        <div *ngIf="title" class="flex mb-0">
            <p class="resultsCardSubtitle font-weight--bold ">{{ 'title' | translate | async }}</p>
            <p class="recordValue" innerHTML="{{ title | highlight : this.searchTerms }}">
                {{ title | highlight : this.searchTerms }}
            </p>
        </div>
        <div *ngIf="author" class="flex mb-0">
            <p class="resultsCardSubtitle font-weight--bold ">{{ 'author' | translate | async }}</p>
            <p class="recordValue" innerHTML="{{ author | notApplicablePipe | async | highlight : this.searchTerms }}">
                {{ author | notApplicablePipe | async | highlight : this.searchTerms }}
            </p>
        </div>
        <div *ngIf="subject" class="flex mb-0">
            <p class="resultsCardSubtitle font-weight--bold ">{{ 'subject' | translate | async }}</p>
            <p class="recordValue" innerHTML="{{ subject | notApplicablePipe | async | highlight : this.searchTerms }}">
                {{ subject | notApplicablePipe | async | highlight : this.searchTerms }}
            </p>
        </div>
        <div *ngIf="keywords" class="flex mb-0">
            <p class="resultsCardSubtitle font-weight--bold ">{{ 'keywords' | translate | async }}</p>
            <p class="recordValue" innerHTML="{{ keywords | notApplicablePipe | async | highlight : this.searchTerms }}">
                {{ keywords | notApplicablePipe | async | highlight : this.searchTerms }}
            </p>
        </div>
        <div *ngIf="file_size" class="flex mb-0">
            <p class="resultsCardSubtitle font-weight--bold ">{{ 'file.size.mb' | translate | async}}</p>
            <p class="recordValue">{{ file_size | megabyteConversionPipe | decimalPipe: 1 }} {{ 'megabyte' | translate | async }}</p>
        </div>
        <div *ngIf="synopsis" lass="flex mb-0">
            <p class="resultsCardSubtitle font-weight--bold ">{{ 'synopsis' | translate | async }}</p>
            <p class="recordValue" innerHTML="{{ synopsis | highlight : this.searchTerms }}">
                {{ synopsis | highlight : this.searchTerms }}
            </p>
        </div>
    </div>
</div>